import { z } from "zod";

import { getServerSideURL } from "@/common/helpers/get-url";
import { httpClient } from "@/services/http";

type Report = z.infer<typeof reportSchema>;

const reportSchema = z.object({
  name: z.string().min(3),
  pathname: z.string().min(1),
  message: z.string().min(1),
  priority: z.enum(["low", "medium", "high"]).optional(),
});

export const sendErrorReport = async (error: Report) => {
  await httpClient.post(`${getServerSideURL()}/cms-api/errors/report`, {
    body: {
      ...reportSchema.parse(error),
      origin: getServerSideURL(),
      status: "unresolved",
      key: Math.random().toString(36),
      events: 1,
      lastEventAt: new Date().toISOString(),
    },
  });
};
